//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'loader-spin',
  props: {
    size: {
      type: String,
      default: '', // accepts '' & 'sm'
    },
    grayscale: {
      type: Boolean,
      default: false,
    },
    grayscaleInvert: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    spinnerClass() {
      return {
        'spinner-sm': this.size === 'sm',
        'spinner-md': this.size === 'md',
        'spinner-lg': this.size === 'lg',
        'spinner-gs': this.grayscale === true,
        'spinner-gs-invert': this.grayscaleInvert === true,
        'spinner-success': this.success,
      };
    },
    spinnerSize() {
      switch (this.size) {
        case 'sm':
          return 16;
        case 'md':
          return 32;
        case 'lg':
          return 64;
        default:
          return 160;
      }
    },
    spinnerStroke() {
      switch (this.size) {
        case 'sm':
          return 1.5;
        case 'md':
          return 2;
        case 'lg':
          return 3;
        default:
          return 4;
      }
    },
    spinnerCenter() {
      return this.spinnerSize / 2;
    },
    spinnerRadius() {
      return this.spinnerSize / (2 * Math.sqrt(2));
    },
  },
};
